import React from "react";

const PropertiesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="30"
      viewBox="0 0 35 30"
      fill="none"
    >
      <path
        d="M26 12.5H29.5V16.5H26"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 20.5H29.5V24.5H26"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 12.5H6V16.5H9.5"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.75 16.25L19.75 12.75L15.75 12.75L15.75 16.25"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 16.5H21.5"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 23L15.75 28.5L19.75 28.5L19.75 23"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 22.75L14 22.75"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 20.5H6V24.5H9.5"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 28.5H33V9.5L25.5 2L22 5.5"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 28.5H2V9.5L9.5 2L13 5.5"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 28.5V9L17.75 2L10 9V28.5H25.5Z"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PropertiesIcon;
